const WALLETS = {
  SOCIOS: "56843177b5e89d4bcb19a27dab7c49e0f33d8d3a6c8c4c7e5274f605e92befd6",
  BITGET: "38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662",
  OKX: "5d9f1395b3a8e848684848dc4147cbd05c8d54bb737eac78fe103901fe6b01a1",
  COIN_98: "2a3c89040ac3b723a1972a33a125b1db11e258a6975d3a61252cd64e6ea5ea01",
  ONTO: "0f5eca2c7f2c9d11c992fdc707575c484ffb751e58e43eaeeea24510bfe8b8dd",
  METAMASK: "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
  RABBY: "18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1",
  TRUST: "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
  LEDGER: "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927",
};

/**
 * This is a list of excluded wallet connect wallet ids.
 *
 * Generated using the following url:
 * https://explorer-api.walletconnect.com/v3/wallets?projectId=YOUR_PROJECT_ID&entries=1000&page=1
 */
export const EXCLUDED_WALLET_IDS = [
  // WALLETS.METAMASK,
];

export const SUPPORTED_WALLETS = [
  WALLETS.SOCIOS,
  // WALLETS.BITGET,
  // WALLETS.OKX,
  // WALLETS.COIN_98,
  // WALLETS.ONTO,
  // WALLETS.METAMASK,
  // WALLETS.RABBY,
  // WALLETS.TRUST,
  // WALLETS.LEDGER,
];
